import { Edit } from "@mui/icons-material";
import { Button, IconButton, Typography } from "@mui/material";
import { MaterialReactTable, MRT_GlobalFilterTextField, MRT_TablePagination, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import CardContainer from "../../../commons/cards/CardContainer";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../styled/Prevencion";

const TableComponent = ({ data, onAdd, onEdit, title }) => {
  const ciiu = useSelector((state) => state.resolucion.ciiu);

  const columns = useMemo(() => [
      {
        accessorKey: 'cuit',
        header: 'CUIT',
        size: 25,
      },
      {
        accessorKey: 'ciiu',
        header: 'CIIU',
        Cell: ({ row }) => (
          ciiu.data.find((e) => (e.id === row.original.ciiu))?.nombre ?? ""
        ),
      },
      {
        accessorKey: 'cantidadEmpleados',
        header: 'Cantidad de Empleados',
        size: 25,
      },
      {
        id: 'actions',
        header: 'Acciones',
        size: 25,
        Cell: ({ row }) => (
          <IconButton onClick={() => onEdit(row.original)}>
            <Edit />
          </IconButton>
        ),
      },
    ],
    [ciiu.data, onEdit]
  );

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    renderEmptyRowsFallback: () => (
      <StyledResolucion.MessageContainer>
        <Typography>No hay registros agregados</Typography>
      </StyledResolucion.MessageContainer>
    ),
    muiTableBodyProps: {
      sx: {
        '& tr:last-child td': { border: 0 },
      },
    },
    renderTopToolbar: ({ table }) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <MRT_GlobalFilterTextField table={table} />
        </div>
      </div>
    ),
    renderBottomToolbar: ({ table }) => (
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px',
        borderTop: '1px solid #e3e1e1'
      }}>
        <MRT_TablePagination table={table} />
        <Button color="primary" onClick={onAdd}>
          Agregar
        </Button>
      </div>
    ),
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
    },
    paginationDisplayMode: 'pages',
    enableRowSelection: false,
    enableColumnFilters: false,
    enableColumnActions: false,
  });

  return (
    <CardContainer
      title={title}
      getData={() => {}}
      loading={false}
      componente={<MaterialReactTable table={table} />}
    />
  );
};

export default TableComponent;